<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        View Document
                    </h1>
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-btn
                        rounded
                        small
                        class="mr-1"
                        @click="dialog_search = true"
                    >
                        <v-icon small class="mr-1">mdi-magnify</v-icon>History
                    </v-btn>
                </v-col>
            </v-row>

            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col :cols="12" md="3" sm="6">
                            <v-text-field
                                @click:clear="
                                    doc_no = ''
                                    getData()
                                "
                                v-model="doc_no"
                                label="NO Document"
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col :cols="12" md="9" sm="6">
                            <v-btn
                                :loading="loading"
                                :disabled="loading"
                                color="deep-orange accent-4"
                                class="ma-2 white--text"
                                @click="getData()"
                            >
                                Search
                                <v-icon right dark>mdi-magnify</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-title>
                    <v-row>
                        <v-col :cols="12">
                            <v-data-table
                                :items="information"
                                :headers="headersNew"
                                :items-per-page="10"
                                :loading="isLoading"
                                :search="search"
                                loading-text="Loading... Please wait"
                            >
                                <template v-slot:[`item.doc_no`]="{ item }">
                                    <span
                                        >{{ item.doc_no }}
                                        <v-btn
                                            class="ma-2"
                                            fab
                                            dark
                                            small
                                            elevation="0"
                                            style="width: 25px; height: 20px"
                                            color="grey"
                                        >
                                            {{ item.cases }}
                                        </v-btn></span
                                    >
                                </template>
                                <template
                                    v-slot:[`item.created_name`]="{ item }"
                                >
                                    <span>{{ item.created_name }}</span>
                                    <v-spacer></v-spacer>
                                    <span>{{ item.created_date }}</span>
                                </template>
                                <template
                                    v-slot:[`item.received_name`]="{ item }"
                                >
                                    <span>{{ item.received_name }}</span>
                                    <v-spacer></v-spacer>
                                    <span>{{ item.received_date }}</span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <v-btn
                                        @click="
                                            showItem(
                                                item.doc_no,
                                                item.created_name,
                                                item.created_date
                                            )
                                        "
                                        class="ma-2"
                                        outlined
                                        small
                                        fab
                                        color="indigo"
                                    >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-title>
            </v-card>

            <v-dialog v-model="dialog" max-width="1600px">
                <v-form method="post" id="nativeFormresponse" v-model="valid">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Detail Document</span>
                        </v-card-title>
                        <v-row class="ml-5">
                            <v-col cols="12" sm="4" md="3" lg="3">
                                <v-btn
                                    :loading="loading"
                                    :disabled="!valid"
                                    style="
                  background-image: linear-gradient(180deg, #f7ff00, #db36a4);
                "
                                    class="ma-2 white--text"
                                    @click="receive()"
                                >
                                    Save
                                    <v-icon right dark>mdi-content-save</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" lg="6">
                                <label
                                    v-if="data_case.length > 0"
                                    style="font-weight: bold"
                                >
                                    {{ data_case[0].doc_no }}
                                </label>
                                <br />
                                <label v-if="data_case.length > 0">
                                    {{ data_case[0].engineer }}
                                </label>
                                <br />
                                <label v-if="data_case.length > 0">
                                    {{ data_case[0].onsite_attime }}
                                </label>
                            </v-col>
                            <v-col cols="12" sm="4" md="3" lg="3">
                                <v-btn
                                    :loading="loading"
                                    :disabled="loading"
                                    :style="
                                        selectreceiveall == true
                                            ? 'background-image: linear-gradient(to left, #23074d , #cc5333);'
                                            : 'background-color:grey'
                                    "
                                    class="ma-2 white--text"
                                    @click="
                                        selectreceiveall == true
                                            ? (selectreceiveall = false)
                                            : (selectreceiveall = true),
                                            receiveAll()
                                    "
                                >
                                    Receive Y All
                                    <v-icon right dark>{{
                                        selectreceiveall == true
                                            ? "mdi-check"
                                            : "mdi-reminder"
                                    }}</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-data-table
                                        :items="data_case"
                                        :headers="headers"
                                        :items-per-page="10"
                                        :loading="isLoading"
                                        :search="search"
                                        loading-text="Loading... Please wait"
                                    >
                                        <template v-slot:[`item.no`]="{ item }">
                                            <span>
                                                {{
                                                    data_case
                                                        .map(function(x) {
                                                            return x.case_id
                                                        })
                                                        .indexOf(item.case_id) +
                                                        1
                                                }}
                                            </span>
                                        </template>
                                        <template
                                            v-slot:[`item.case_id`]="{ item }"
                                        >
                                            <span>{{ item.case_id }} </span>
                                            <br />
                                            <span class="text-color-red">
                                                {{
                                                    item.is_quotation !== null
                                                        ? "quotation"
                                                        : ""
                                                }}</span
                                            >
                                        </template>

                                        <template
                                            v-slot:[`item.image`]="{ item }"
                                        >
                                            <view-image
                                                v-if="item.images.length > 0"
                                                :id="item.subcase_id"
                                                :data="item"
                                                title="cso"
                                            />
                                        </template>
                                        <template
                                            v-slot:[`item.doc_remark`]="{
                                                item,
                                            }"
                                        >
                                            {{ item.doc_remark }}
                                        </template>

                                        <template
                                            v-slot:[`item.action`]="{ item }"
                                        >
                                            <v-bottom-navigation horizontal>
                                                <v-btn
                                                    :color="
                                                        item.select == 'Y'
                                                            ? 'green accent-3'
                                                            : ''
                                                    "
                                                    @click="
                                                        updateStatus(
                                                            item.subcase_id,
                                                            'Y'
                                                        )
                                                    "
                                                >
                                                    <span>Y</span>
                                                    <v-icon
                                                        >mdi-check-circle</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    :color="
                                                        item.select == 'N'
                                                            ? 'red accent-3'
                                                            : ''
                                                    "
                                                    @click="
                                                        updateStatus(
                                                            item.subcase_id,
                                                            'N'
                                                        )
                                                    "
                                                >
                                                    <span>N</span>
                                                    <v-icon
                                                        >mdi-close-circle</v-icon
                                                    >
                                                </v-btn>
                                                <br />
                                                <br />
                                                <br />
                                            </v-bottom-navigation>
                                            <!-- tem.documentcomment -->
                                            <div
                                                style="margin-top:10px;"
                                                v-if="item.select == 'N'"
                                            >
                                                <v-autocomplete
                                                    v-model="item.remark"
                                                    :items="messagecomment"
                                                    label="Remark"
                                                    :rules="commentR"
                                                    required
                                                    small-chips
                                                    outlined
                                                    clearable
                                                    multiple
                                                    style="color: yellow"
                                                    color="blue-grey lighten-2"
                                                >
                                                    <template
                                                        v-slot:selection="{
                                                            item,
                                                            select,
                                                            selected,
                                                        }"
                                                    >
                                                        <v-chip
                                                            :input-value="
                                                                selected
                                                            "
                                                            close
                                                            small
                                                            @click="select"
                                                            @click:close="
                                                                remove(item, i)
                                                            "
                                                        >
                                                            <strong>{{
                                                                item
                                                            }}</strong>
                                                        </v-chip>
                                                    </template>
                                                </v-autocomplete>
                                                {{ item.doc_remark }}
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close"
                                >Cancel</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>

            <v-row justify="center">
                <v-dialog
                    v-model="dialog_search"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click="dialog_search = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>
                                <!-- Settings -->
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                                >Save</v-btn
                            >
            </v-toolbar-items>-->
                        </v-toolbar>
                        <v-list three-line subheader>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-row>
                                        <v-col cols="3">
                                            <v-text-field
                                                label="Search"
                                                v-model="data_search.searchtext"
                                                prepend-inner-icon="mdi-magnify"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-menu
                                                v-model="modal"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        v-model="dateRangeText"
                                                        label="Date range"
                                                        dense
                                                        prepend-inner-icon="mdi-calendar"
                                                        readonly
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="data_search.date"
                                                    range
                                                    @change="get_date()"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="1" class="text-right">
                                            <v-btn
                                                rounded
                                                small
                                                class="ml-5"
                                                @click="get_history()"
                                            >
                                                <v-icon small class="mr-1"
                                                    >mdi-magnify</v-icon
                                                >Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-simple-table class="table-inv">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr class="col-tr-1">
                                                            <th
                                                                class="text-center"
                                                            >
                                                                #
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Project
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Case ID
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Csono
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Status
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Receive Date
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Receive By
                                                            </th>
                                                            <th
                                                                class="text-center"
                                                            >
                                                                Engineer
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="(row,
                                                            index) in data_history"
                                                            :key="index"
                                                        >
                                                            <td>
                                                                {{ index + 1 }}.
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.project_name
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.case_id
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{ row.csono }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.doc_status
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.received_date
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.received_name
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                {{
                                                                    row.engineer_name
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import Image from "../../components/ViewImage"

import { mapState, mapMutations } from "vuex"

export default {
    computed: {
        ...mapState(["isLoading"]),
        dateRangeText() {
            this.data_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.data_search.date.join(" ~ ")
        },
    },
    components: {
        "view-image": Image,
    },
    data() {
        return {
            valid: false,
            commentR: [(v) => !!v || "comment is required"],
            messagecomment: [
                "ขาด เขียนใบงานให้ตรงกับ Project",
                "ขาด วัน/เดือน/ปี_เวลา เเจ้งงาน",
                "ขาด วัน/เดือน/ปี_เวลา เข้าดำเนินการ",
                "ขาด S/N ที่เเจ้งซ่อม",
                "ขาด เลขงานที่แจ้ง",
                "ขาด ตราประทับ",
                "ขาด ชื่อ-เบอร์โทร และที่อยู่ ลายมือตัวบรรจงของลูกค้า",
                "ขาด ชื่อสาขา/หน่วยงาน หรือ Project ที่แจ้ง ให้ครบและถูกต้อง",
            ],
            selectreceiveall: false,
            showpic1: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            loader: null,
            loading: false,
            doc_no: "",
            selecteddoc: "",
            data: [],
            information: [],
            selected: [],
            data_case: [],
            image: {
                images: [],
            },
            dialog: false,
            dialog_search: false,
            modal: false,
            data_search: {
                searchtext: "",
                date: [],
            },
            data_history: [],
            headersNew: [
                {
                    text: "No Document",
                    value: "doc_no",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "CE Sent",
                    value: "created_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Admin Receive",
                    value: "received_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Actions",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                },
            ],
            headers: [
                {
                    text: "No",
                    value: "no",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Project",
                    value: "project_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "CaseID",
                    value: "case_id",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Onsite Date",
                    value: "onsite_at",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "CSO No",
                    value: "csono",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Site Name",
                    value: "site_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Solution",
                    value: "solution",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Image",
                    value: "image",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Actions",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                    sortable: false,
                },
                {
                    text: "Doc Remark",
                    value: "doc_remark",
                    class: "text-uppercase blue darken-3 white--text",
                },
            ],
            search: "",
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_history() {
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/document/history`
            const { data } = await axios.post(url, this.data_search, options)
            this.data_history = data
            this.mutateIsLoading()
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        async save(params) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/document/pending/${this.selecteddoc}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                for (let i = 0; i < this.data_case.length; i++) {
                    if (
                        this.data_case[i].select == "" ||
                        this.data_case[i].select == undefined ||
                        this.data_case[i].select == null
                    ) {
                        this.$swal(
                            "กรุณาเลือกปุ่ม Y หรือ N ",
                            "Please Select Y or N",
                            "info"
                        )
                        exit()
                    }
                }
                const { data } = await axios.post(
                    url,
                    { data: this.data },
                    options
                )
                if (data == "update - complete") {
                    swal({
                        title: "Receive Complete",
                        icon: "success",
                        button: "OK",
                    }).then((result) => {
                        this.getData()
                        this.close()
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },
        async receive() {
            //เขียนใหม่ 17/05/21
            this.mutateIsLoading()
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/document/pending/${this.selecteddoc}`,
                    { data: this.data_case },
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                )
                .then((response) => {
                    this.mutateIsLoading()
                    swal({
                        title: "Receive Complete",
                        icon: "success",
                        button: "OK",
                    }).then((result) => {
                        this.getData()
                        this.close()
                    })
                })

            // var data1 = []
            // var remark = ""
            // this.data_case.map((each, index) => {
            //     if (each.select == "Y") {
            //         remark = ""
            //     } else if (each.select == "N") {
            //         remark = each.documentcomment
            //     }
            //     data1.push({
            //         caseid: each.subcase_id,
            //         status: each.select,
            //         remark: remark,
            //     })
            // })
            // this.data = [...data1]
            // // console.log(this.data, "ggg");
            // this.save(this.data)
        },
        receiveAll() {
            var data = []
            if (this.selectreceiveall == true) {
                this.data_case.map((each, index) => {
                    this.data_case[index].doc_status = "Y"
                    this.data_case[index].select = "Y"
                    data.push({ caseid: each.subcase_id, status: "Y" })
                })
            } else {
                this.data_case.map((each, index) => {
                    this.data_case[index].doc_status = "N"
                    this.data_case[index].select = "N"
                    data.push({ caseid: each.subcase_id, status: "N" })
                })
            }

            this.data = [...data]
            // this.save(this.data);
        },
        updateStatus(id, params) {
            this.data_case.map((each, index) => {
                if (each.subcase_id == id) {
                    this.data_case[index].doc_tus = params == "Y" ? "Y" : "N"
                    this.data_case[index].doc_status = params == "Y" ? "Y" : "N"
                    this.data_case[index].select = params == "Y" ? "Y" : "N"
                }
                if (each.doc_tus != "Y") {
                    this.selectreceiveall = false
                } else {
                    this.selectreceiveall = true
                }
            })
        },
        close() {
            this.dialog = false
        },
        async showItem(params, name, date) {
            this.selectreceiveall = false
            this.selecteddoc = params
            const url = `${process.env.VUE_APP_ROOT_API}/api/document/pending/${params}`
            try {
                const { data } = await axios.get(url)
                this.data_case = []
                var status = {
                    doc_tus: "",
                    // select: "",
                    documentcomment: "",
                    engineer: "",
                }
                // console.log(data)
                data.map((each) => {
                    each.cases.map((res) => {
                        var ob = [...res.cso]
                        this.image.images = []
                        ob.map((src) => {
                            this.image.images.push(this.showpic1 + src.file_id)
                        })
                        // status = {
                        //     doc_tus: res.doc_status == "Received" ? "Y" : "N",
                        //     select: res.doc_status == "Received" ? "Y" : "N",
                        //     engineer: name,
                        //     onsite_attime: date,
                        //     documentcomment: "",
                        // }
                        this.data_case.push(
                            Object.assign({}, res, this.image, status)
                        )
                    })
                })
            } catch (error) {
                console.log(error)
            }

            this.dialog = true
        },
        async getData() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/document/pending`
            try {
                this.mutateIsLoading()
                const { data } = await axios.post(
                    url,
                    { doc_no: this.doc_no },
                    options
                )

                this.information = data
                // console.log(this.information, "gg");
                this.mutateIsLoading()
                // data.map((each) => {
                //   var ob = [...each.images];
                //   this.image.images = [];
                //   ob.map((src) => {
                //     this.image.images.push(
                //       this.showpic1 + src.file_store_name + "/" + src.file_name
                //     );
                //   });
                //   this.data.push(Object.assign({}, each, this.image));
                // });
            } catch (error) {
                console.log(error)
            }
        },
    },
    //     async getData() {
    //         const url = `${process.env.VUE_APP_ROOT_API}/api/announce-active`
    //         try {
    //             const { data } = await axios.get(url)
    //             data.map(each =>{
    //                var ob = [ ... each.images ]
    //                this.image.images = []
    //                ob.map(src=>{
    //                   this.image.images.push( this.showpic1+src.file_store_name+'/'+src.file_name )
    //                })
    //               this.data.push(Object.assign({}, each , this.image ))
    //             })
    //         } catch (error) {
    //             console.log(error)
    //         }
    //     },
    // },
    watch: {
        loader() {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        },
    },
}
</script>
<style scoped>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
.image {
    display: none;
}
</style>
